require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/cart/addtocart.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/cart/addtocart.legacy.js
// module id = 642
// module chunks = 31